import React, { memo, useCallback, useContext, useMemo } from 'react'

import {
  Usage, Button, Icon, Tooltip, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { openUsageModal } from 'Pods/ThreeDStudio/Store/actions/ui'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

function UsageButton({ isOpen = true }) {
  const studioAccessTier = useThreeDStudioStore(state => state.subscription.studioAccessTier)
  const isUsageModalOpen = useThreeDStudioStore(state => state.ui.isUsageModalOpen)
  const { extractingCoreStyles } = useContext(ThreeDStudioPageContext)

  const handleClick = useCallback(() => {
    openUsageModal()
  }, [])

  const buttonIcon = useMemo(
    () => <Icon svgComponent={Usage} color="dark" notSpaced />,
    [],
  )

  if (!studioAccessTier && !extractingCoreStyles) {
    return null
  }

  const button = (
    <Button
      type="ghost"
      variant={isOpen ? 'with-icon' : 'only-icon'}
      icon={buttonIcon}
      customClass={classnames('usage-button', !isOpen && 'usage-button--collapsed')}
      onClick={handleClick}
      aria-label="Usage"
      aria-haspopup="dialog"
      aria-expanded={isUsageModalOpen}
    >
      {isOpen ? 'Usage' : null}
    </Button>
  )

  if (isOpen) {
    return button
  }

  return (
    <Tooltip
      content="Usage"
      id="usage-button-tooltip"
      place="right"
      containerClass="usage-button-tooltip"
      className="usage-button-tooltip__trigger"
      clickable
    >
      {button}
    </Tooltip>
  )
}

UsageButton.propTypes = {
  isOpen: bool,
}

export default memo(UsageButton)
